import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  PLATFORM_ID,
  ViewChild,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppPreferences } from '../core/services/app-preferences';
import { FeaturesSection } from './components/features-section/features-section';
import { HeroSection } from './components/hero-section/hero-section';
import { LandingHeader } from './components/landing-header/landing-header';
import { StepsSection } from './components/steps-section/steps-section';
import { SupportCard } from './components/support-card/support-card';

@Component({
  selector: 'app-landing-page',
  imports: [RouterLink, LandingHeader, HeroSection, FeaturesSection, StepsSection, SupportCard],
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
})
export class LandingPage implements AfterViewInit {
  readonly preferences = inject(AppPreferences);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private scrollFrame = 0;
  showStickyCta = false;

  @ViewChild('featuresSection', { read: ElementRef })
  private featuresSection?: ElementRef<HTMLElement>;

  @ViewChild('ctaWrap', { read: ElementRef })
  private ctaWrap?: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.scheduleStickyCtaUpdate();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.scheduleStickyCtaUpdate();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.scheduleStickyCtaUpdate();
  }

  private scheduleStickyCtaUpdate(): void {
    if (!this.isBrowser || this.scrollFrame) {
      return;
    }

    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = 0;
      this.updateStickyCta();
    });
  }

  private updateStickyCta(): void {
    const featuresElement = this.featuresSection?.nativeElement;
    const ctaElement = this.ctaWrap?.nativeElement;

    if (!featuresElement || !ctaElement) {
      return;
    }

    const featuresRect = featuresElement.getBoundingClientRect();
    const ctaRect = ctaElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const headerTriggerOffset = 72;
    const hasReachedFeaturesHeader = featuresRect.top <= headerTriggerOffset;
    const hasReachedOriginalCta = ctaRect.top + 30 <= viewportHeight;

    this.showStickyCta = hasReachedFeaturesHeader && !hasReachedOriginalCta;
  }
}
